import React from "react";

const STATUS = {
  DISCOVERED: { color: "#A7ABB0", bg: "rgba(167,171,176,0.12)" },
  PROCESSING: { color: "#4ea3ff", bg: "rgba(78,163,255,0.12)" },
  WAITING: { color: "#A7ABB0", bg: "rgba(167,171,176,0.12)" },
  RETRY: { color: "#f5c451", bg: "rgba(245,196,81,0.12)" },
  HELD: { color: "#f87171", bg: "rgba(248,113,113,0.12)" },
  FAILED: { color: "#f87171", bg: "rgba(248,113,113,0.12)" },
  RESEARCHING: { color: "#4ea3ff", bg: "rgba(78,163,255,0.12)" },
  DRAFTING: { color: "#f5c451", bg: "rgba(245,196,81,0.12)" },
  "QC REVIEW": { color: "#9b8cff", bg: "rgba(155,140,255,0.12)" },
  "HUMAN REVIEW": { color: "#FF8A1F", bg: "rgba(255,138,31,0.14)" },
  APPROVED: { color: "#3ecf8e", bg: "rgba(62,207,142,0.12)" },
  SCHEDULED: { color: "#2dd4bf", bg: "rgba(45,212,191,0.12)" },
  PUBLISHED: { color: "#F5F5F2", bg: "rgba(245,245,242,0.1)" },
  REJECTED: { color: "#f87171", bg: "rgba(248,113,113,0.12)" },
};

export const STATUS_LIST = Object.keys(STATUS);

export default function StatusPill({ status, small = false }) {
  const s = STATUS[status] || (status.startsWith('Waiting') ? STATUS.WAITING : status.startsWith('Processing ·') ? STATUS.PROCESSING : null) || ({ 'Waiting for Writer': STATUS.WAITING, Image: STATUS.PROCESSING,
    Translation: STATUS.PROCESSING, 'Translation Retry': STATUS.DRAFTING, Held: STATUS.REJECTED,
    'Ready to Publish': STATUS.APPROVED, Published: STATUS.PUBLISHED, 'Not Publishable': STATUS.REJECTED,
    'Source Research': STATUS.RESEARCHING })[status] || STATUS.DISCOVERED;
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full font-mono-td font-medium"
      style={{
        color: s.color,
        background: s.bg,
        fontSize: small ? "0.58rem" : "0.64rem",
        padding: small ? "2px 8px" : "3px 10px",
        letterSpacing: "0.04em",
      }}
      data-testid={`status-pill-${status.replace(/\s/g, "-").toLowerCase()}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.color }} />
      {status}
    </span>
  );
}
